import ConditionReportRequestSearchModel from "@/modules/condition-report-requests/ConditionReportRequestSearch.model";
import ConditionReportRequestsService from "@/modules/condition-report-requests/ConditionReportRequestsService";
import {store} from "@/plugins/vuex";
import {
  CONDITION_REPORT_REQUESTS_TABLE_NAME,
  SOURCE_CONDITION_REPORT_REQUESTS_TABLE,
} from "@/modules/constants";
import _ from "lodash";
import i18n from "@/shared/i18n";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new ConditionReportRequestSearchModel(),
    extraFilters: {},
    expand: 'created_by',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['email', 'created_at'],
      defaultFields: [
        'email',
        'first_name',
        'last_name',
        'message',
        'created_at',
        'status',
        'sent_at',
        'rejected_at',
        'condition_report',
        'requested_by',
        'customer',
        'inventory',
        'rejected_by',
        'sent_by',
        'sale_no',
        'sale_title',
        'lot_no',
        'department',
        'category',
      ],
    }
  }
};
let getDefaultFields = () => {
  return [
    {key: 'email', label: i18n.t('Email'), sortable: true, isVisible: true, expand: ''},
    {key: 'first_name', label: i18n.t('First Name'), sortable: true, isVisible: true, expand: ''},
    {key: 'last_name', label: i18n.t('Last Name'), sortable: true, isVisible: true, expand: ''},
    {key: 'message', label: i18n.t('Message'), sortable: true, isVisible: true, expand: ''},
    {key: 'created_at', label: i18n.t('Created At'), sortable: true, isVisible: true, expand: ''},
    {key: 'created_by', label: i18n.t('Created By'), sortable: true, isVisible: true, expand: 'created_by'},
    {key: 'status', label: i18n.t('Status'), sortable: true, isVisible: true, expand: ''},
    {key: 'rejected_at', label: i18n.t('Rejected At'), sortable: true, isVisible: true, expand: ''},
    {key: 'rejected_by', label: i18n.t('Rejected By'), sortable: true, isVisible: true, expand: 'rejected_by'},
    {key: 'condition_report', label: i18n.t('Condition Report'), sortable: true, isVisible: true, expand: 'condition_report'},
    {key: 'customer', label: i18n.t('Customer'), sortable: true, isVisible: true, expand: 'customer'},
    {key: 'inventory', label: i18n.t('Inventory'), sortable: true, isVisible: true, expand: 'inventory'},
    {key: 'sent_at', label: i18n.t('Sent At'), sortable: true, isVisible: true, expand: ''},
    {key: 'sent_by', label: i18n.t('Sent By'), sortable: true, isVisible: true, expand: 'sent_by'},
    {key: 'sale_no', label: i18n.t('Sale No'), sortable: true, isVisible: true, expand: 'reservation.auction'},
    {key: 'sale_title', label: i18n.t('Sale Title'), sortable: true, isVisible: true, expand: 'reservation.auction'},
    {key: 'lot_no', label: i18n.t('Lot No'), sortable: true, isVisible: true, expand: 'reservation'},
    {key: 'department', label: i18n.t('Department'), sortable: true, isVisible: true, expand: 'inventory.department'},
    {key: 'category', label: i18n.t('Category'), sortable: true, isVisible: true, expand: 'inventory.category'},
    {key: 'actions', label: i18n.t('Actions'), sortable: true, isVisible: true, expand: ''},
  ]
}

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    sendModal: {
      show: false,
      object: null,
      source: null
    },
    statuses: [
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Sent'), value: 'sent'},
      {key: i18n.t('Rejected'), value: 'rejected'}
    ],
    tableData: {
      global: getDefaultTableData(),
      inventory: getDefaultTableData(),
      sale: getDefaultTableData(),
      send_modal: getDefaultTableData(),
    }
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: CONDITION_REPORT_REQUESTS_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...currentTableData.pagination, search: currentTableData.search, ordering: ordering}
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',');

      data.expand = `${expand},${defaultExpand}`;
      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await ConditionReportRequestsService.getConditionReportRequests(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new ConditionReportRequestSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    updateExtraFilters({commit}, extraFilters) {
      commit('updateExtraFilters', extraFilters);
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    async hideModal({commit}) {
      commit('hideModal');
    },
    async showSendModal({commit}, {object = null, source} = {}) {
      commit('showSendModal', {object: _.cloneDeep(object), source});
    },
    async hideSendModal({commit}) {
      commit('hideSendModal');
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async createConditionReportRequest({dispatch, state}, payload) {
      let response = await ConditionReportRequestsService.createConditionReportRequest(payload, ''); // TODO Adjust expand
      if (response.success) {
        if (state.modal.source === SOURCE_CONDITION_REPORT_REQUESTS_TABLE) {
          dispatch('getTableData');
        }
      }
      return response;
    },
    async updateConditionReportRequest({commit}, conditionReportRequest) {
      let response = await ConditionReportRequestsService.updateConditionReportRequest(conditionReportRequest.uuid, conditionReportRequest, ''); // TODO Adjust expand
      if (response.success) {
        commit('updateConditionReportRequest', response.body);
      }
      return response;
    },
    async updateConditionReportRequestPartially({commit}, conditionReportRequest) {
      let response = await ConditionReportRequestsService.updateConditionReportRequestPartially(conditionReportRequest.uuid, conditionReportRequest, ''); // TODO Adjust expand
      if (response.success) {
        commit('updateConditionReportRequest', response.body);
      }
      return response;
    },
    async removeConditionReportRequest({dispatch}, bidder) {
      let response = await ConditionReportRequestsService.removeConditionReportRequest(bidder.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: (state) => state.modal.show = false,
    showSendModal: (state, {object, source}) => {
      state.sendModal.show = true;
      state.sendModal.object = object;
      state.sendModal.source = source;
    },
    hideSendModal: (state) => {
      state.sendModal.show = false;
      state.sendModal.object = null;
      state.sendModal.source = null;
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateExtraFilters: (state, extraFilters) => state.tableData[state.tableSource].extraFilters = extraFilters,
    updateConditionReportRequest: (state, request) => {
      const index = state.tableData[state.tableSource].rows.findIndex(i => i.uuid === request.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...request};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
